import React from 'react';
import { LAYER_ICON } from '@marvelapp/theme';
import { Icon, PinTL, ToolbarButton } from '@marvelapp/ui';
export default function LayersButton(_a) {
    var onClick = _a.onClick;
    return (React.createElement(PinTL, { padding: 10 },
        React.createElement(ToolbarButton, { alignItems: "center", display: "flex", fill: "slate", fontFamily: 0, onClick: onClick, paddingLeft: 14 },
            React.createElement(Icon, { display: "block", height: 19, marginRight: 2, paths: LAYER_ICON, viewBox: "0 0 19 19", width: 19 }),
            "Layers")));
}
